export default {
      id: "play-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }